import { Children, ReactNode } from 'react';

export const initHeight = (children?: ReactNode, height?: number, maxVisibleItems?: number) => {
  return children && Children.count(children) > 0 && !height && maxVisibleItems;
};

export const calculateHeight = (refs: (HTMLLIElement | null)[], maxVisibleItems: number | null = 0) => {
  return refs.reduce((acc, curr, idx) => {
    if (curr && maxVisibleItems && idx < maxVisibleItems) {
      const { height } = curr.getBoundingClientRect();
      return acc + height;
    }
    return acc;
  }, 0);
};
